export default __webpack_public_path__ + "static/media/02.04.090.a144e809.png";